import React, { FC, useRef, useEffect } from 'react';

export const ContentWithScripts: FC<{ html: string }> = ({ html }) => {
    const id = useRef(Math.random().toString().substr(2));

    useEffect(() => {
        const container = document.getElementById(id.current);
        const allScripts = (container?.getElementsByTagName(
            'script',
        ) as unknown) as HTMLScriptElement[];
        const notFound = !allScripts || allScripts.length < 1;
        if (notFound) {
            if (process.env.NODE_ENV !== 'production') {
                console.info("allScripts was empty: ", allScripts);
            }
            return;
        }
        allScripts.forEach((script) => {
            const newScript = document.createElement('script');
            newScript.innerHTML = script.innerHTML;
            newScript.id = Math.random().toString().substr(2);
            if (script.src) {
                newScript.src = script.src;
            }
            script.parentNode?.replaceChild(newScript, script);
        });
    }, []);

    return <div className="cws content" id={id.current} dangerouslySetInnerHTML={{ __html: html }} />;
};
